import "./Appsumo.scss";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { MultiLanguageUrl } from "../../constants/multiLanguage.constant";

type Props = {};

function Appsumo({}: Props) {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [error, setError] = useState<any>(null);

  const checkUser = async (code: string) => {
    if (code) {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_DOMAIN}/partner/appsumo/check-user`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              code: code
            })
          }
        );

        if (!response.ok) {
          const responseData = await response.json();
          if (response.status == 400 && responseData.code == "RSPNKO001") {
            navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}/register`);
          }
          return;
        }

        const data = await response.json();

        return data;
      } catch (error: any) {
        setError(error.message);
        navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}/register`);
      }
    }
  };

  useEffect(() => {
    const fetch = async () => {
      const result: {
        element: {
          licensekey: string;
        };
        message: string;
        code: "ok" | "error";
      } = await checkUser(code as string);

      if (result.code == "ok") {
        navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}/login`);
      } else {
        navigate(
          `/${
            MultiLanguageUrl[i18n.language] || "en-US"
          }/partner/appsumo/register?key=${result.element.licensekey}`
        );
      }
    };

    if (code) {
      fetch();
    } else {
      navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}/register`);
    }
  }, [code]);

  return (
    <div className="tw-flex tw-w-full tw-h-screen tw-items-center tw-justify-center">
      <div className="three-body">
        <div className="three-body__dot"></div>
        <div className="three-body__dot"></div>
        <div className="three-body__dot"></div>
      </div>
    </div>
  );
}

export default Appsumo;
